var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleep = function SvgSleep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#FFC220",
    r: 14.067
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10h-.586l1.293-1.293A1 1 0 0 0 20 7h-3a1 1 0 1 0 0 2h.586l-1.293 1.293A1 1 0 0 0 17 12h3a1 1 0 1 0 0-2zM29 7h-2.586l3.293-3.293A1 1 0 0 0 29 2h-5a1 1 0 1 0 0 2h2.586l-3.293 3.293A1 1 0 0 0 24 9h5a1 1 0 1 0 0-2z",
    fill: "#69c6f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17c-1.659 0-2.622-1.164-2.798-1.397a1 1 0 0 1 .195-1.401.998.998 0 0 1 1.4.196c.019.024.464.603 1.202.603.03 0 .755-.007 1.2-.6a1 1 0 1 1 1.599 1.2c-1 1.333-2.508 1.4-2.8 1.4zm12.601-2.8a.998.998 0 0 0-1.4.2c-.445.593-1.17.6-1.2.6-.738 0-1.184-.578-1.202-.603a1 1 0 1 0-1.595 1.205c.176.233 1.139 1.397 2.798 1.397.292 0 1.8-.067 2.8-1.4a1.001 1.001 0 0 0-.199-1.4zM16 20c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z",
    fillOpacity: 0.5
  })));
};
export default SvgSleep;